import { Injectable } from "@angular/core";
import { ConsumptionsOmieService } from "@edp-services/consumptions-omie.service";
import {
    EConsumptionOmieActions,
    GetOmieConsumption,
    SetOmieConsumption,
    SetOmiePrice,
    SetOmieWeeklyAverage,
} from "@edp-store/actions/consumption-omie.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class ConsumptionOmieEffects {
    @Effect()
    getWeeklyAverage$ = this.actions$.pipe(
        ofType(EConsumptionOmieActions.GetOmieWeeklyAverage),
        switchMap(() => this.consumptionsOmieService.getWeeklyAverage().pipe(catchError((error: Error) => of(error)))),
        switchMap(response => {
            if (response instanceof Error) {
                return of(new SetOmieWeeklyAverage(null));
            }
            return of(new SetOmieWeeklyAverage(response[0] || null));
        })
    );

    @Effect()
    getConsumptionOmie$ = this.actions$.pipe(
        ofType(EConsumptionOmieActions.GetOmieConsumption),
        switchMap((action: GetOmieConsumption) =>
            this.consumptionsOmieService.getConsumption(action.payload).pipe(catchError((error: Error) => of(error)))
        ),
        switchMap(response => {
            if (response instanceof Error) {
                return of(new SetOmieConsumption(null));
            }
            return of(new SetOmieConsumption(response[0] || null));
        })
    );

    @Effect()
    getOmiePrice$ = this.actions$.pipe(
        ofType(EConsumptionOmieActions.GetOmiePrice),
        switchMap(() => this.consumptionsOmieService.getOmiePrice().pipe(catchError((error: Error) => of(error)))),
        switchMap(response => {
            if (response instanceof Error) {
                return of(new SetOmiePrice(null));
            }
            
            return of(new SetOmiePrice(response[0] || null));
        })
    );

    constructor(private actions$: Actions, private consumptionsOmieService: ConsumptionsOmieService) {}
}
